import React, { useEffect, useRef, useState } from "react";
import { createBoard, getStates, getStatus } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { toBase64 } from "../../Services/commonHelper";

const AddBoard = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: null,
        name: null,
        status: null,
        state_id: null,
        logo: null,
        type: null, 
        description: null
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const [state, setState] = useState([]);
    const uploadRef = useRef(null);
    const uploadLogoRef = useRef(null);

    const [previewImage, setPreviewImage] = useState({
        logo: ""
    });

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isNotAllowed = Boolean(Number(reqData.status) == 0 || isNaN(Number(reqData.status)));
        if (isNotAllowed) {
            toast.error("Status is required");
        } else {
            setLoader(true);
            let { ok } = await createBoard(reqData);
            if (ok) {
                toast.success("Success");
                onCloseWithApi();
            }
            setLoader(false);
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const getStateCall = async () => {
        let { ok, data } = await getStates({});
        if (ok) {
            setState(data?.records);
        }
    };

    useEffect(() => {
        getStatusCall();
        getStateCall();
        if (data?.data) {
            const { name, state_id, status, logo, id, type, description } = data?.data;
            setReqData({ name, state_id, status, logo, id, type, description })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Board" : "Edit Board"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>State</label>
                                            <select required value={reqData?.state_id} onChange={(e) => handleChange("state_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select State</option>
                                                {state?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Type</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Type"
                                                required
                                                value={reqData?.type}
                                                onChange={(e) => handleChange("type", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.logo ? "Change Logo" : "Add Logo"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.logo || reqData?.logo) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.logo ? previewImage?.logo : reqData?.logo}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "logo")} />
        </div>
    );
};

export default AddBoard;